
import React from 'react'

// components
import {
  CRow,
  CCol,
  CFormLabel,
  CImage,
  CButton,
  CAccordion, 
  CAccordionBody, 
  CAccordionHeader, 
  CAccordionItem
} from '@coreui/react-pro'

import FormTextInput from './FormTextInput'
import FormPrice from './FormPrice'

// icons
import AddMoreIconWhite from '../../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from 'src/components/custom-styles/buttonStyles'

const FormProjectTerms = ({
  colSize,
  inputLabel,
  className,
  project_terms,
  handleAddProjectTerms,
  errors,
  handleChange,
  handleRemoveProjectTerms,
  isDetail,
}) => {
  return (
    <CCol lg={colSize} className={className} id='project_terms'>
      <div className='mb-3 d-grid gap-2 d-md-flex justify-content-between align-items-center'>
        <CFormLabel>
          {inputLabel}
        </CFormLabel>
        {
          !isDetail && (
            <CButton
              onClick={() => handleAddProjectTerms()}
              style={styleButtonVars2}
            >
              <CImage fluid src={AddMoreIconWhite} className='me-2' />
              {project_terms?.length > 0 ? 'Add More' : 'Add'}
            </CButton>
          )
        }
      </div>
      {project_terms?.length > 0 ? (
        project_terms?.map((inputField, index) => {
          return (
            <CAccordion activeItemKey={isDetail ? 0 : index+1}>
              <CAccordionItem itemKey={index+1} className='mb-2'>
                <CAccordionHeader>Terms {index + 1}</CAccordionHeader>
                <CAccordionBody>
                  <CRow className="mb-4">
                    <FormTextInput 
                      id='term_name'
                      name='term_name'
                      colSize='6'
                      className='mb-3'
                      inputLabel='Term Name'
                      placeholder='Enter term name...'
                      value={inputField?.term_name}
                      handleTextInput={(e) => handleChange(e, index)}
                      feedbackInvalid={errors?.project_terms?.length > 0 && errors?.project_terms[index]?.term_name}
                      invalid={errors?.project_terms?.length > 0 && errors?.project_terms[index]?.term_name}
                      disabled={isDetail}
                    />
                    <FormTextInput 
                      id='term_percentage'
                      name='term_percentage'
                      colSize='6'
                      className='mb-3'
                      inputLabel='Term Percentage'
                      placeholder='Enter term percentage...'
                      value={inputField?.term_percentage}
                      handleTextInput={(e) => handleChange(e, index)}
                      feedbackInvalid={errors?.project_terms?.length > 0 && errors?.project_terms[index]?.term_percentage}
                      invalid={errors?.project_terms?.length > 0 && errors?.project_terms[index]?.term_percentage}
                      disabled={isDetail}
                    />
                    <FormPrice
                      id='term_value'
                      name='term_value'
                      colSize='6'
                      inputLabel='Term Value'
                      placeholder='Enter term value...'
                      value={inputField?.term_value}
                      handlePriceInput={(e) => handleChange(e, index)}
                      feedbackInvalid={errors?.project_terms?.length > 0 && errors?.project_terms[index]?.term_value}
                      invalid={errors?.project_terms?.length > 0 && errors?.project_terms[index]?.term_value}
                      disabled={isDetail}
                    />
                    <FormPrice
                      id='term_tax_value'
                      name='term_tax_value'
                      colSize='6'
                      inputLabel='Term Tax Value'
                      placeholder='Enter term tax value...'
                      value={inputField?.term_tax_value}
                      handlePriceInput={(e) => handleChange(e, index)}
                      feedbackInvalid={errors?.project_terms?.length > 0 && errors?.project_terms[index]?.term_tax_value}
                      invalid={errors?.project_terms?.length > 0 && errors?.project_terms[index]?.term_tax_value}
                      disabled={isDetail}
                    />
                  </CRow>
                  <CRow>
                    <CCol lg={1}>
                      {
                        project_terms?.length > 1 && !isDetail && (
                          <CButton
                            style={styleButtonVars2}
                            onClick={() => {handleRemoveProjectTerms(inputField, index)}}
                          >
                            Delete
                          </CButton>
                        )
                      }
                    </CCol>
                  </CRow>
                </CAccordionBody>
              </CAccordionItem>
            </CAccordion>

          )
        })
      ) : !isDetail ? (
        <div className='alert alert-secondary'><b>You can add project terms</b></div>
      ) : (
        <div className='alert alert-secondary'><b>You not have project terms</b></div>
      )}
    </CCol>
  )
}

export default FormProjectTerms
